export default [

  {
    path: '/zxs/rank',
    name: 'rank',
    component: () => import('@/views/zxs/rank'),
    meta: {
      title: '自习时长排行榜-快来一起自习上榜拿奖励-高考直通车'
    }
  }
]
